import { render } from "./CheckCapture.vue?vue&type=template&id=7b82cb8e"
import script from "./CheckCapture.vue?vue&type=script&lang=js"
export * from "./CheckCapture.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__